import { localStore } from '@utils/localStore';

export const restoreSessionId = (type: 'admin' | 'user', id: string) => {
  const key = `app-${type}`;
  const item = localStore.getItem(key);
  const parsed = typeof item === 'string' ? (JSON.parse(item) as Record<string, string>) : item;
  localStore.updateItem(key, { ...parsed, id });
};
